// src/components/Products.js
import { useEffect, useState } from "react";
import styled from "styled-components";
import Product from "./Product";
import axios from "axios";

const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const Products = ({ mode, country, type, filters, sort }) => {
  const [items, setItems] = useState([]);
  const [filtered, setFiltered] = useState([]);

  // 1️⃣ Fetch data depending on mode
  useEffect(() => {
    const fetchData = async () => {
      try {
        let res;

        if (mode === "realestate") {
          res = await axios.get("/api/AffordableRealestates");
        } else {
          res = await axios.get("/api/AffordableCars");
        }

        setItems(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, [mode]);

  // 2️⃣ Apply filters
  useEffect(() => {
    let data = items;

    // 🚗 Cars: filter by country (USA, Germany, Japan)
    if (mode === "cars" && country) {
      data = data.filter((item) => item.country === country);
    }

    // 🏠 Real Estate: filter by TYPE (Villa, Land, Apartment, etc.)
    if (mode === "realestate" && type) {
      data = data.filter((item) => item.type === type);
    }

    // 🏠 Real Estate: filter by CITY
    if (mode === "realestate" && filters?.city) {
      data = data.filter((item) => item.city === filters.city);
    }

    // 🚗 Cars: year & odometer filters
    if (mode === "cars" && filters) {
      if (filters.year) {
        data = data.filter((item) => Number(item.year) >= Number(filters.year));
      }
      if (filters.odometer) {
        data = data.filter(
          (item) => Number(item.odometer) <= Number(filters.odometer)
        );
      }
    }

    setFiltered(data);
  }, [items, country, type, filters, mode]);

  // 3️⃣ Sorting (cars only)
  useEffect(() => {
    if (mode !== "cars") return;

    if (sort === "newest") {
      setFiltered((prev) =>
        [...prev].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      );
    } else if (sort === "asc") {
      setFiltered((prev) => [...prev].sort((a, b) => a.price - b.price));
    } else if (sort === "desc") {
      setFiltered((prev) => [...prev].sort((a, b) => b.price - a.price));
    }
  }, [sort, mode]);

  return (
    <Container>
      {filtered.map((item) => (
        <Product item={item} key={item._id} mode={mode} fromStore={false} openInNewTab={true} />
      ))}
    </Container>
  );
};

export default Products;
